import React from 'react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';

interface TrackGapProps {
    gapStart: number;
    gapEnd: number;
    totalDuration: number;
}

export const TrackGap: React.FC<TrackGapProps> = ({
    gapStart,
    gapEnd,
    totalDuration,
}) => {
    const { t } = useTranslation(I18nNamespace.VIDEO);

    if (totalDuration <= 0) return null;

    const leftPercent = Math.max(0, (gapStart / totalDuration) * 100);
    const rightPercent = Math.min(100, (gapEnd / totalDuration) * 100);

    if (rightPercent <= leftPercent) return null;

    const widthPercent = rightPercent - leftPercent;

    return (
        <div
            className="absolute h-full flex items-center cursor-pointer pointer-events-auto"
            data-recording-gap
            style={{ left: `${leftPercent}%`, width: `${widthPercent}%` }}
        >
            <Tooltip>
                <TooltipTrigger asChild>
                    <div
                        className="w-full h-[2px]"
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            backgroundImage:
                                'repeating-linear-gradient(45deg, transparent, transparent 4px, rgba(0, 0, 0, 0.3) 4px, rgba(0, 0, 0, 0.3) 8px)',
                        }}
                    />
                </TooltipTrigger>
                <TooltipContent>
                    {t('streaming.messages.noRecordingAtTime')}
                </TooltipContent>
            </Tooltip>
        </div>
    );
};
